import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { ForgetPasswordAction } from "../../Redux/Auth/AuthActions";
import { absoluteUrl } from "../../_helper";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { emailRegex } from "../../constants/globals";
import RowLoader from "../../Components/UI/RowLoader";

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.Auth);

  let ForgetPasswordInitialData = {
    email: "",
  };

  const forgetPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .matches(emailRegex, "Invalid email")
      .required("Required"),
  });

  const onErrorHandler = (word) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: word,
    });
  };

  const onSuccessHandler = (word) => {
    Swal.fire({
      icon: "success",
      title: "Please Check Your Email",
      text: word,
    });
  };

  return (
    <>
      <img
        src={absoluteUrl("imgs/loginLogo.png")}
        className="login-logo !-tw-mt-10 tw-mx-auto"
        alt=""
      />
      {/* <h4
        className="tw-text-white tw-text-center !tw-m-0 tw-font-bold tw-text-lg !-tw-mt-10"
        style={{ textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        UNITERS ACADEMY
      </h4>{" "} */}
      <h3 className="tw-text-lg text-center mb-3 !-tw-mt-10">
        Forget Password
      </h3>
      <Formik
        initialValues={ForgetPasswordInitialData}
        validationSchema={forgetPasswordSchema}
        onSubmit={(values) => {
          // same shape as initial values
          dispatch(
            ForgetPasswordAction(
              {
                email: values?.email,
                type: "client",
              },
              onSuccessHandler,
              onErrorHandler
            )
          );
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div className="form-group mb-3">
              {/* <label className='c-white' htmlFor="email">Email</label> */}
              <div className="input-icon">
                <span className="fa fa-envelope login-icon-field tw-text-secondary tw-text-xl"></span>
                <Field
                  name="email"
                  type="email"
                  placeholder="Email"
                  className={`form-control tw-border-b-2 pr-3 tw-border-secondary !tw-border-x-0 !tw-border-t-0 !tw-rounded-none ${
                    errors.email && touched.email
                      ? "tw-border !tw-border-red-500"
                      : ""
                  }`}
                />
              </div>
              <ErrorMessage
                name="email"
                component="div"
                className="invalid-feedback"
              />
            </div>

            <button
              type="submit"
              className="btn !tw-bg-primary tw-w-full tw-text-white mt-3 hover:!tw-text-[#eee] tw-h-10"
            >
              {isLoading ? <RowLoader /> : "Submit"}
            </button>
          </Form>
        )}
      </Formik>
      <div className="mt-4 d-block text-center">
        <Link
          className="text-white"
          style={{ fontSize: "20px" }}
          to={"/auth/login"}
        >
          Back to login
        </Link>
      </div>
    </>
  );
};

export default ForgetPassword;
